import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { FieldContainer } from '@sharedComponents/Field';
import { Button } from '@sharedComponents/DesignSystem/Inputs';
import { translate, checkIsVisible, buildNewcomerFormComponentsArray } from '@utils';
import { DownloadIcon } from '@images/icons';
import { setIsOpenDownloadModal } from '@actions/lettersPageActions';
import { SubmissionData } from '@types';
import {
  canDownloadSubmissionSelector,
  currentSubmissionFormDataSelector,
  currentSubmissionOriginSections,
} from '@selectors/submission';
import { currentUserSelector } from '@selectors/user';
import { LangEnum } from '@enums';
import { useEffect, useState } from 'react';

interface props {
  form: SubmissionData;
  handleFieldChange: (key: string) => (value: { [key: string]: never }) => void;
  lang?: LangEnum;
}

const Form = (props: props) => {
  const [formData, setFormData] = useState([]);

  const { form, handleFieldChange, lang } = props;
  const submissionFormData = useSelector(currentSubmissionFormDataSelector);
  const currentUser = useSelector(currentUserSelector);
  const canDownload = useSelector(canDownloadSubmissionSelector);
  const currentSubmissionSections = useSelector(currentSubmissionOriginSections);

  useEffect(() => {
    if (currentSubmissionSections?.length) {
      setFormData(buildNewcomerFormComponentsArray(currentSubmissionSections, lang));
    }
    if (!currentSubmissionSections?.length) {
      setFormData(submissionFormData?.components);
    }
  }, [submissionFormData, currentSubmissionSections, lang]);

  const dispatch = useDispatch();

  const handleOpenDownloadModal = () => {
    dispatch(setIsOpenDownloadModal(true));
  };

  return (
    <div className="form-wrapper" data-testid="form">
      {formData && formData.length !== 0 && (
        <>
          {formData
            .filter((item) => checkIsVisible(form, item.conditions))
            .map((item) => (
              <FieldContainer
                key={item.key}
                user={currentUser}
                form={form}
                handleChange={handleFieldChange(item.key)}
                schema={item}
                lang={lang}
              />
            ))}
          {canDownload && (
            <Button startIcon={<DownloadIcon />} type="basic" onClick={handleOpenDownloadModal}>
              {translate('download')}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export { Form };
